const actionTypes = {
  TOGGLE_HANDOVER_MODAL_VISIBLE: Symbol('TOGGLE_HANDOVER_MODAL_VISIBLE'),
  SET_HANDOVER_INFO_LOADING: Symbol('SET_HANDOVER_INFO_LOADING'),
  INIT_HANDOVER_INFO: Symbol('INIT_HANDOVER_INFO'),
  INIT_HANDOVER_AMOUNT_LIST: Symbol('INIT_HANDOVER_AMOUNT_LIST'),
  RESET_HANDOVER_INFO: Symbol('RESET_HANDOVER_INFO'),
  UPDATE_REPORT_STATE: Symbol('UPDATE_REPORT_STATE'),
  HANDOVER_BAS_BUSINESS: Symbol('HANDOVER_BAS_BUSINESS'),
  HANDOVER_MEMBER_CARD: Symbol('HANDOVER_MEMBER_CARD'),
};

export default actionTypes;
